module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/queen.a7f1f8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/queen.jpg
// module id = nVqz
// module chunks = 0